import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import MailTemplateBlock from "../../Components/MailTemplates";
import PageHeader from "../../Components/Common/PageHeader";
import "./style.scss";

const STORAGE_KEY = "mailtemplate_selected_workspace";

const MailTemplatesPage = () => {
  const [workspaces, setWorkspaces] = useState([]);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ""
  );
  const [loadingWorkspaces, setLoadingWorkspaces] = useState(true);

  useEffect(() => {
    Utils.setPageTitle("Email Templates");
  }, []);

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const response = await Utils._apiRequest({
          path: Enums.endpoints.workspace.ALL,
          type: "GET",
          query: { page: 1, limit: 100 },
        });
        setWorkspaces(response.data || []);

        // If saved workspace no longer exists, clear selection
        if (selectedWorkspaceId && response.data) {
          const exists = response.data.some(
            (ws) => ws._id === selectedWorkspaceId
          );
          if (!exists) {
            setSelectedWorkspaceId("");
            localStorage.removeItem(STORAGE_KEY);
          }
        }
      } catch (error) {
        console.log("Failed to fetch workspaces:", error.message);
      } finally {
        setLoadingWorkspaces(false);
      }
    };

    fetchWorkspaces();
  }, []);

  const handleWorkspaceChange = (e) => {
    const value = e.target.value;
    setSelectedWorkspaceId(value);
    if (value) {
      localStorage.setItem(STORAGE_KEY, value);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="Email Templates"
          description="Manage email templates for your workspaces"
          icon={faEnvelope}
        />

        <section className="mail-templates-workspace-card mb-4">
          <Row className="g-3 align-items-end">
            <Col md={7} lg={8}>
              <div className="mail-templates-workspace-copy">
                <span className="mail-templates-kicker">Workspace Context</span>
                <h5>Choose where templates are managed</h5>
                <p>
                  Templates are scoped by workspace. Select one workspace to view, create, and
                  maintain localized email content.
                </p>
              </div>
            </Col>
            <Col md={5} lg={4}>
              <Form.Group>
                <Form.Label className="fw-semibold">Select Workspace</Form.Label>
                <Form.Select
                  value={selectedWorkspaceId}
                  onChange={handleWorkspaceChange}
                  disabled={loadingWorkspaces}
                >
                  <option value="">
                    {loadingWorkspaces ? "Loading workspaces..." : "-- Select a workspace --"}
                  </option>
                  {workspaces.map((ws) => (
                    <option key={ws._id} value={ws._id}>
                      {ws.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </section>

        {selectedWorkspaceId ? (
          <MailTemplateBlock workspaceId={selectedWorkspaceId} />
        ) : (
          <div className="mail-templates-empty-state text-center">
            <div className="mail-templates-empty-state__icon-wrap">
              <FontAwesomeIcon icon={faLayerGroup} />
            </div>
            <h6>Ready to manage email templates</h6>
            <p className="mb-0">Please select a workspace to view and manage templates.</p>
          </div>
        )}
      </div>
    </main>
  );
};

export default MailTemplatesPage;
